import DataEntry from './DataEntry';
import Dropzone from '../../../vendor/dropzone';

export default class DataFolder extends DataEntry{

    createMarkup() {
        // this.$html = `
        //     <li>
        //         <a href="#" data-type="${this.entry.type}" data-id="${this.id}">
        //             <i class="fa fa-folder"></i> <span>${this.entry.title}</span>
        //         </a>
        //     </li>
        // `;

        this.$li = document.createElement('li');

        this.$link = document.createElement('a');
        this.$link.setAttribute('href', "#");
        this.$link.setAttribute('data-id', this.id);
        this.$link.setAttribute('data-type', "folder");

        this.$fa = document.createElement('i');
        this.$fa.classList.add('fa', 'fa-folder');

        this.$span = document.createElement('span');
        this.$span.innerText = this.entry.title;

        this.$link.appendChild(this.$fa);
        this.$link.appendChild(this.$span);
        this.$li.appendChild(this.$link);
        this.$html = this.$li;
    }

    setClickEvent() {
        this.$link.on('click', (e) => {
            e.preventDefault();
            if (this.isOpen) {
                this.closeFolder();
            } else {
                this.openFolder();
            }
        });
    }

    openFolder() {
        this.disableEntry();
        securearea.getFolderData(this.id, this.$el);

        $(window).one('entriesloaded', (e) => {
            this.enableEntry();
            this.isOpen = true;
            this.$el.addClass('open');

            if ((this.permissions & 8) === 8) {
                this.createDropzone();
            }

            if (securearea.deeplinkData && securearea.deeplinkData[securearea.deeplinkDepth]) {
                const link = securearea.deeplinkData[securearea.deeplinkDepth];
                securearea.deeplinkDepth++;
                const theLink = document.querySelector(`[data-id="${link.id}"]`);

                if (theLink) {
                    if (link.folder) {
                        if (theLink) {
                            theLink.click();
                            if (securearea.deeplinkData.length == securearea.deeplinkDepth) {
                                theLink.classList.add("focus");
                                setTimeout(function() {
                                    // Code, der erst nach 2 Sekunden ausgeführt wird
                                    theLink.scrollIntoView({behavior: "smooth"});
                                }, 500);

                            }
                        }
                    } else {
                        theLink.classList.add("focus");
                        setTimeout(function() {
                            // Code, der erst nach 2 Sekunden ausgeführt wird
                            theLink.scrollIntoView({behavior: "smooth"});
                        }, 500);
                    }
                }
            }
        });
    }

    closeFolder() {
        this.isOpen = false;
        this.$el.find('ul, .dropzone-multi, .noentries').remove();
        this.$el.removeClass('open');
        this.$el.closest('li.open').find('.dropzone-multi').show();
    }

    refreshFolder() {
        this.refreshPermissions();
        this.closeFolder();
        this.openFolder();
    }

    createDropzone() {
        let parentId = this.id;
        let element = this.$el;

        $('.dropzone-multi').hide();
        element.append('<div class="dropzone dropzone-multi dropzone-theme" id="drop_' + parentId +'"><button class="btn" data-action="getfolder"><i class="fa fa-refresh"></i> Ordner aktualisieren</button></div>');

        element.$dropzone = new Dropzone('#drop_' + parentId, {
            url: dataUrl + "?action=" + dataActionPrefix + "createfile&folderId=" + parentId,
            // maxFilesize: maxFileSize,
            // acceptedfiles: allowedFileExtensions,
            clickable: true,
            uploadMultiple: true,
            timeout: 300000,
            // thumbnailWidth: 100,
            dictDefaultMessage: "Dateien hierhin ziehen<br />oder<br />hier klicken um Dialog zu öffnen.",
            thumbnailMethod: "contain",
            previewTemplate: `<div class="dz-preview dropzone-preview">
                <div class="filename">
                    <span class="dropzone-success-mark"><i class="fa fa-check"></i></span><span class="dropzone-error-mark"><i class="fa fa-exclamation-triangle"></i></span>
                    <span data-dz-name class=""></span>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div>
                <div class="error-msg"><span data-dz-errormessage><small>nicht hochgeladen</small></span></div>
            </div>`,
            accept: function (file, done) {
                let extsplit = file.name.split('.');
                let ext = extsplit[extsplit.length-1].toLowerCase();

                if (allowedFileExtensions.search(ext) == -1) {
                    file.errorMessage = "Die Datei <strong>" + file.name +"</strong> hat einen unerlaubten Dateityp.";
                    done("Unerlaubter Typ.");
                } else if (file.size > maxFileSize) {
                    file.errorMessage = "Die Datei <strong>" + file.name + "</strong> ist zu schwer.";
                    done("Unerlaubte Grösse.");
                } else {
                    done();
                }
            },
            error: function (file) {
                $(file.previewElement).addClass('dz-error');

                let errormsg = "Der Server ist momentan nicht erreichbar. Bitte wenden Sie sich an den Administrator oder versuchen Sie es später nochmal.";
                if (file.errorMessage) {
                    errormsg = file.errorMessage;
                }
                let json = { success: false, errors: [errormsg], errorcode: 0, debug: ["Dropzone Error: wrong file size or dropzone error", errormsg] }
                securearea.showError("createfile", json);
            },
            successmultiple: function (dzresult, wpresult) {
                $('.errormsg').remove();

                if (wpresult.success) {
                    $('#drop_' + parentId + ' .btn[data-action="getfolder"]').addClass('show');
                } else {
                    securearea.showError("createfile", wpresult);
                    return false;
                }
            },
            drop: function() {
                $('.dropzone .btn[data-action="getfolder"]').removeClass('show');
            }
        });

        $('.dropzone .btn[data-action="getfolder"]').click((e) => {
            e.preventDefault();
            this.refreshFolder();
            $(e.target).removeClass('show');
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea-next/classes/DataFolder.js
 **/